'use strict'

module.exports = (function () {
    /**
    * @ngdoc method
    * @name olbLogin
    * @description Handles custom online banking (olb) login behavior
    **/

    var initialize = function () {
        rememberUsername();
    }

    function rememberUsername() {
        var olbForm = document.querySelector('.oa-login form');
        if (olbForm && olbForm.length > 0) {
            var olbUsernameEl = olbForm.querySelector('[name="u"]');
            var olbRememberUsernameEl = olbForm.querySelector('[name="olbRememberUsername"]');
            if (olbUsernameEl && olbRememberUsernameEl && localStorage) {
                // load remembered username
                var prevUsername = localStorage.getItem('olbUsername');
                if (prevUsername) {
                    olbUsernameEl.value = prevUsername
                }
                // remember username
                olbForm.addEventListener('submit', function (e) {
                    var olbRememberUsernameCheckedEl = olbForm.querySelector('[name="olbRememberUsername"]:checked');
                    var hasRememberUsername = olbRememberUsernameCheckedEl ? olbRememberUsernameEl.value : false;
                    if (hasRememberUsername) {
                        localStorage.setItem('olbUsername', olbUsernameEl.value);
                    }
                });
            }
        }
    }

    return {
        initialize: initialize
    };
}())